export const EMAIL_ALREADY_IN_USED = 'You are already registered.';
